// extracted by mini-css-extract-plugin
export default {"togglersection":"toggler_togglersection__R2IXQ","headline":"toggler_headline__nVAGA","activelist":"toggler_activelist__grijC"};